import React, { useState } from 'react';
import { Header } from '../Header';
import { ThemeProvider } from 'styled-components';
import { themes } from '../Theme';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const [theme, updateTheme] = useState(themes.long);

  return (
    <ThemeProvider theme={theme}>
      <Header updateTheme={updateTheme} />
      {children}
    </ThemeProvider>
  );
};
